export const AppColors = {
    accent_color: "rgba(166, 31, 56, 1)",
    text_color: "#FFFFFF",
};
